import React from 'react';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import EventBookingsBasicInfoComponent from './event-booking-basic-info.component';

export const EventBookingsComponent = ({
    selectEventBookings, handleInnerFormChange, back, handleFormSubmit,handleBasicFormChange,libraryData,users,events,eventTickets
}: any) => {
    const tabItems = [
        {
            id: 1,
            title: 'EventBookings Basic Information',
            component: <EventBookingsBasicInfoComponent
                handleInnerFormChange={handleInnerFormChange}
                selectEventBookings={selectEventBookings}
                handleBasicFormChange={handleBasicFormChange}
                libraryData={libraryData}
                users={users}
                events={events}
                eventTickets={eventTickets}
            />,
            isVisible: true,
        },
    ]

    return (
        <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen">
            <TabContainer tabItems={tabItems} />

            <div className='flex w-full justify-end items-end'>
                <button
                    onClick={back}
                    type='button'
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                >
                    Back
                </button>
                {/* <button
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                    onClick={handleFormSubmit}
                    type="submit"
                >
                    Save
                </button> */}
            </div>
        </div>
    )
}

export default EventBookingsComponent;
